/**
 * Ability catalog registry (AB-02).
 * Seed kits register via OCP; Entity keeps Ashe legacy id property access.
 */
import { createAbilitySpec } from './abilitySpec.js';
import { ASHE_ABILITY_DEFS } from './kits/asheKit.js';
import { GAREN_ABILITY_DEFS } from './kits/garenKit.js';
import { RYZE_ABILITY_DEFS } from './kits/ryzeKit.js';
import { ANNIE_ABILITY_DEFS } from './kits/annieKit.js';
import { SIVIR_ABILITY_DEFS } from './kits/sivirKit.js';
import { DARIUS_ABILITY_DEFS } from './kits/dariusKit.js';
import { SETT_ABILITY_DEFS } from './kits/settKit.js';
import { JAX_ABILITY_DEFS } from './kits/jaxKit.js';
import { LUX_ABILITY_DEFS } from './kits/luxKit.js';
import { BRAND_ABILITY_DEFS } from './kits/brandKit.js';
import { VEIGAR_ABILITY_DEFS } from './kits/veigarKit.js';
import { SORAKA_ABILITY_DEFS } from './kits/sorakaKit.js';
import { LULU_ABILITY_DEFS } from './kits/luluKit.js';
import { NAMI_ABILITY_DEFS } from './kits/namiKit.js';
import { EZREAL_ABILITY_DEFS } from './kits/ezrealKit.js';
import { CAITLYN_ABILITY_DEFS } from './kits/caitlynKit.js';
import { ZED_ABILITY_DEFS } from './kits/zedKit.js';
import { KATARINA_ABILITY_DEFS } from './kits/katarinaKit.js';
import { YASUO_ABILITY_DEFS } from './kits/yasuoKit.js';
import { RIVEN_ABILITY_DEFS } from './kits/rivenKit.js';
import { IRELIA_ABILITY_DEFS } from './kits/ireliaKit.js';

export const ABILITY_CATALOG = {};

const BY_CHAMP_SLOT = new Map();

function champSlotKey(champKey, slot) {
  return `${String(champKey).toLowerCase()}:${String(slot).toUpperCase()}`;
}

/**
 * @param {object} raw
 * @returns {Readonly<object>}
 */
export function registerAbility(raw) {
  const spec = createAbilitySpec(raw);
  if (ABILITY_CATALOG[spec.id]) {
    throw new Error(`Ability already registered: ${spec.id}`);
  }
  ABILITY_CATALOG[spec.id] = spec;
  BY_CHAMP_SLOT.set(champSlotKey(spec.champKey, spec.slot), spec);
  return spec;
}

function registerKit(defs) {
  for (const def of defs) {
    registerAbility(def);
  }
}

registerKit(ASHE_ABILITY_DEFS);
registerKit(GAREN_ABILITY_DEFS);
registerKit(RYZE_ABILITY_DEFS);
registerKit(ANNIE_ABILITY_DEFS);
registerKit(SIVIR_ABILITY_DEFS);
registerKit(DARIUS_ABILITY_DEFS);
registerKit(SETT_ABILITY_DEFS);
registerKit(JAX_ABILITY_DEFS);
registerKit(LUX_ABILITY_DEFS);
registerKit(BRAND_ABILITY_DEFS);
registerKit(VEIGAR_ABILITY_DEFS);
registerKit(SORAKA_ABILITY_DEFS);
registerKit(LULU_ABILITY_DEFS);
registerKit(NAMI_ABILITY_DEFS);
registerKit(EZREAL_ABILITY_DEFS);
registerKit(CAITLYN_ABILITY_DEFS);
registerKit(ZED_ABILITY_DEFS);
registerKit(KATARINA_ABILITY_DEFS);
registerKit(YASUO_ABILITY_DEFS);
registerKit(RIVEN_ABILITY_DEFS);
registerKit(IRELIA_ABILITY_DEFS);

export function getAbilitySpec(abilityId) {
  return ABILITY_CATALOG[abilityId] || null;
}

export function getAbilityByChampSlot(champKey, slot) {
  return BY_CHAMP_SLOT.get(champSlotKey(champKey, slot)) || null;
}

export function listAbilityIdsForChamp(champKey) {
  const key = String(champKey).toLowerCase();
  return Object.values(ABILITY_CATALOG)
    .filter((s) => s.champKey === key)
    .map((s) => s.id);
}
